<template>
  <div class="container">
    <Nav></Nav>
    <div class="index_hearderImg">
      <img :src="TokenImg" alt="" />
    </div>
    <div class="breadcrumb_center">
      <el-breadcrumb
        class="el-icon-arrow-right"
        separator-class="el-icon-arrow-right"
      >
        <img src="../assets/qingye/indexImg.png" alt="" />
        <div>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>青词元</el-breadcrumb-item>
          <el-breadcrumb-item>{{ TokenName }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>

    <div class="token index_center">
      <div class="token_wrap">
        <div class="token_left">
          <div class="AiBar">
            <el-menu class="el-menu-vertical-demo" mode="horizontal" active-text-color="#2968BD"
              :default-active="tabIndex + ''">
              <el-menu-item v-for="(item, index) in tokenMenuList" :key="item.path"
                :index="index + ''"
                @click="$router.push(item.path)">
                <span slot="title">{{ item.name }}</span>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
        <div class="token_right">
          <router-view></router-view>
        </div>
      </div>
      <SubmitFrom></SubmitFrom>
    </div>
    <Foot style="margin-top: 120px"></Foot>
  </div>
</template>
<script>
import Nav from "./components/navBar";
import Foot from "./components/Foot";
import SubmitFrom from "./components/SubmitFrom";

export default {
  components: {
    Nav,
    Foot,
    SubmitFrom,
  },
  name: "Token",
  data() {
    return {
      tabIndex: 0,
      tokenMenuList: [
        {
          name: "青词元token平台",
          path: "/Token/CompanyProfile",
          imgSrc: require("../assets/qingye/AiServices.png"),
        },
        {
          name: "青词元AI视频生成",
          path: "/Token/AIVideo",
          imgSrc: require("../assets/qingye/AiServices.png"),
        },
        {
          name: "青词元AI漫剧生成",
          path: "/Token/AIComic",
          imgSrc: require("../assets/qingye/AiServices.png"),
        },
        {
          name: "青词元去水印平台",
          path: "/Token/WatermarkRemoval",
          imgSrc: require("../assets/qingye/AiServices.png"),
        },
        {
          name: "青词元音乐生成平台",
          path: "/Token/MusicGeneration",
          imgSrc: require("../assets/qingye/AiServices.png"),
        },
        {
          name: "青词元算力平台",
          path: "/Token/ComputingPower",
          imgSrc: require("../assets/qingye/AiServices.png"),
        },
      ],
      TokenName: "token平台",
      TokenImg: require("../assets/qingye/AiServices.png"),
    };
  },
  watch: {
    $route(to) {
      this.tokenMenuList.forEach((item, index) => {
        if (item.path == to.path) {
          this.tabIndex = index;
          this.TokenName = item.name;
          this.TokenImg = item.imgSrc;
        }
      });
    },
  },
  created() {
    this.$store.state.tabbar = null;
    this.tokenMenuList.forEach((item, index) => {
      if (item.path == this.$route.path) {
        this.tabIndex = index;
        this.TokenName = item.name;
        this.TokenImg = item.imgSrc;
      }
    });
  },
};
</script>
<style scoped>
.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 60px;
  line-height: 60px;
  margin: 0;
  border-bottom: 2px solid transparent;
  color: #909399;
  width: 180px !important;
}

.index_center {
  width: 1200px;
  margin: 0 auto;
}

.token_left {
  padding-top: 30px;
}

.token_wrap {
  padding-top: 60px;
  display: flex;
  width: 1200px;
}

.token_right {
  padding-left: 65px;
  width: 100%;
}

.breadcrumb_center {
  width: 100%;
  background-color: #f6f7f8;
  display: flex;
  justify-content: space-around;
  height: 50px;
}
.el-icon-arrow-right {
  display: flex;
  align-items: center;
  width: 1200px;
  color: #666666;
}
.el-icon-arrow-right img {
  padding: 0 10px 0px 0;
}
.index_hearderImg {
  display: flex;
  justify-content: center;
}
.index_hearderImg img {
  width: 100%;
  height: 100%;
}
div /deep/ .el-breadcrumb__inner.is-link {
  font-weight: normal;
  color: #606266;
}

.token {
  display: flex;
}

.AiBar>>>.el-menu--horizontal>.el-menu-item.is-active {
  border-right: 2px solid #2968bd;
  border-bottom: none;
  background-image: linear-gradient(to right, #ffffff, rgba(41, 104, 189, 0.1));
}

.AiBar>>>.el-menu--horizontal>.el-menu-item {
  border-bottom: none;
  width: 140px;
}

.AiBar>>>.el-menu.el-menu--horizontal {
  border-bottom: none;
  display: flex;
  flex-direction: column;
  align-items: end;
}
</style>



// WEBPACK FOOTER //
// src/views/Token.vue